export default "__VITE_ASSET__4ba065d7__"